<template>
    <metainfo>
        <template v-slot:title="{ content }">{{ content ? `${content}` : `krainaabc.tvp.pl` }}</template>
    </metainfo>
    <Header v-if="!isPageGame"></Header>
    <router-view :key="$route.path"></router-view>
    <Footer v-if="!isPageGame"></Footer>

    <div class="modal-backdrop" :class="{'login': isModalLogin }" v-if="isModalBackdrop"></div>
</template>

<script>
import AOS from 'aos';
import checkIsLogged from "./mixins/checkIsLogged";
import pastePrevent from "./mixins/pastePrevent";
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";

export default {
    components: {
        Header,
        Footer,
    },
    mixins: [checkIsLogged, pastePrevent],
    computed: {
        isModalBackdrop() {
            return this.$store.getters.isModalBackdrop;
        },
        userData() {
            return this.$store.getters.getUserData;
        },
        isModalLogin() {
            return this.$store.getters.getModalLogin;
        },
        isPageGame() {
            return this.$route.path.includes("/gry/");
        }
    },
    watch: {
        isModalBackdrop(val) {
            if(val) {
                document.body.classList.add('backdrop');
            } else {
                document.body.classList.remove('backdrop');
            }
        },
        userData() {
            if(this.userData && this.userData.data && this.userData.data._id) {
                localStorage.setItem("user_id", this.userData.data._id);
            } else {
                localStorage.removeItem("user_id");
            }
        }
    },
    mounted() {
        AOS.init({
            once: true
        })
        const checkLogged = this.checkUserCookie();
        if (checkLogged === true) {
            if(!this.$store.getters.isLoggedIn) {
                this.$store.dispatch("changeIsLoggedIn"); 
            }
            this.$store.dispatch("globalUserData");
        }

        window.addEventListener('online', () => {
            this.$store.dispatch("changeModalErrorLoadingState", false);
            this.$store.dispatch("changeModalBackdrop", false);  
        }, false);
        window.addEventListener('offline', () => {
            this.$store.dispatch("changeModalErrorLoadingState", true);
            this.$store.dispatch("changeModalBackdrop", true);  
        }, false);

        this.pastePrevent();
    }
}
</script>